/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Sub_Quickstart_Key_Replacement_NoteInputs */



/**
* | output |
* | --- |
* | "Replace oai-gk_YOUR_KEY with one of your API keys above." |
*
* @param {Gateway_Sub_Quickstart_Key_Replacement_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_sub_quickstart_key_replacement_note = /** @type {((inputs?: Gateway_Sub_Quickstart_Key_Replacement_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Sub_Quickstart_Key_Replacement_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ersetze oai-gk_YOUR_KEY durch einen deiner API-Schlüssel oben.")
	return /** @type {LocalizedString} */ ("Replace oai-gk_YOUR_KEY with one of your API keys above.")
});